import React, { useRef, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import withFirst from "../../../../../pages/details/hoc/withFirst";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react'
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { useCallback } from "react";
import DisplayTransition from "../../../../components/transitions/display-transition"
import { useEffect } from "react";
import { fetchCommentIds } from "../../../../../../api";
import Mask from "../../../../components/mask/index"
import ProductStarScore from "../../module/product-star-score";
import { FormattedMessage } from "react-intl";
import ReactPlayer from "react-player/lazy";

const BabiesVideo = props =>{
    const { videoId, play } = props;
    const playerRef = useRef(null);
    const [muted, setMted] = useState(true);
    const [player, setPlayer] = useState(false);
    const [showPlayer,setShowPlayer] = useState(false);

    useEffect(() =>{
        if(!player && play){
            setShowPlayer(true);
        }else{
            setShowPlayer(false);
            setPlayer(false);
        }
    },[play]);

    const youtubePlayEvent = () => {
        setShowPlayer(true);
    }

    const videoMuted = () =>{
        let playerItem = playerRef.current?.getInternalPlayer();

        if(playerItem.isMuted()){
            setMted(false);
        }else{
            setMted(true);
        }
    }

    return <div className={classes.BabiesVideo} onClick={() =>youtubePlayEvent()}>
        {
            showPlayer ? <React.Fragment>
                <ReactPlayer className={classes.Player}
                    ref={playerRef}
                    width='100%'
                    height='100%'
                    url={`https://www.youtube.com/watch?v=${videoId}`}
                    muted={muted}
                    playing={player}
                    onReady={() => {
                        setPlayer(true)
                    }}
                    onEnded={()=>{
                        setPlayer(false);
                        setShowPlayer(false);
                    }}
                    config={{
                        youtube: {
                            playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 },
                            embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 }
                        }
                    }} 
                    
                />
                <div className={classes.BoFangMask}></div>
                <span className={`${classes.YoutubeMuted} ${!muted?classes.MutedActive:""}`} onClick={videoMuted}></span>
            </React.Fragment> : <React.Fragment>
                <img className={classes.BoFangBtn} src={`${IMAGE_GEEKO_LTD}/chicme/20220627/play.svg`} alt="Bo Fang"></img>
            </React.Fragment>
        }
    </div>
}

const ProductBabiesModalItem = props =>{
    const { babiesItem, babiesItems, onClose, aPlay } = props;
    const [currentImage,setCurrentImage] = useState(babiesItem?.images?.[0]);
    const [currentIndex,setCurrentIndex] = useState(1);

    useEffect(()=>{
        if(babiesItem?.id){
            setCurrentImage(babiesItem?.images?.[0]);
            setCurrentIndex(1);
        }
    },[babiesItem?.id]);

    const getName = (name) => {
        if (name && name.length > 2) {
            return name.replace(name.substr(1, name.length - 2), '***')
        }
        return name;
    }

    return <div className={classes.ProductBabiesModalItem}>
        <div className={classes.Hd}>
            <div className={classes.Toggle}>
                <div className={`${babiesItems?.length > 1 && babiesItems[0]?.productCommentId === babiesItem?.id ? classes.Disabled : ""}`} onClick={() => props?.onBabiesLook(false)}>
                    <Iconfont className={classes.Icon}>&#xe693;</Iconfont>
                    <span><FormattedMessage id="previous" defaultMessage="Previous" /></span>
                </div>

                <div className={`${babiesItems?.length > 1 && babiesItems[babiesItems.length - 1]?.productCommentId === babiesItem?.id ? classes.Disabled : ""}`} onClick={() => props?.onBabiesLook(true)}>
                    <span><FormattedMessage id="next" defaultMessage="Next" /></span>
                    <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
                </div>
            </div>

            <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe69a;</Iconfont>
        </div>

        <div className={classes.Content}>
            <div className={classes.Left}>
                <ul>
                    {
                        babiesItem?.images?.map((item,index)=>{
                            return <li key={index} onClick={()=>{
                                setCurrentImage(item);
                                setCurrentIndex(index+1);
                            }}>
                                <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="babies" />
                            </li>
                        })
                    }
                </ul>
            </div>

            <div className={classes.Right}>
                {
                    babiesItem?.images?.length > 0 && <div className={classes.Num}>
                        <span>{currentIndex}</span>
                        <span>/</span>
                        <span>{babiesItem?.images?.length}</span>
                    </div>
                }
                
                <img className={classes.Image} src={`${IMAGE_GEEKO_LTD}/comment/medium/${currentImage}`} alt="babies" />
                
                {
                    currentIndex===1 && babiesItem?.videoIds?.length > 0 && <BabiesVideo videoId={babiesItem?.videoIds?.[0]} play={aPlay} />
                }
                
                <div className={classes.Comment}>
                    <div className={classes.CommentInfo}>
                        <div>
                            <span className={classes.Name}>{getName(babiesItem?.customerName)}</span>
                            <ProductStarScore starScore={babiesItem?.score} isComment className={classes.CommentStar} />
                        </div>

                        <div className={classes.Time}>{babiesItem?.createTime}</div>
                    </div>

                    <div className={classes.CommentContent}>{babiesItem?.content}</div>
                </div>
            </div>
        </div>
    </div>
}

const ProductBabiesModal = props =>{
    const { babiesItem, babiesData } = props;

    return <>
        <DisplayTransition in={!!babiesItem?.id && babiesData?.length > 0} className={classes.ProductBabiesModal}>
            <div>
                <ProductBabiesModalItem {...props} />
            </div>
        </DisplayTransition>

        {
            !!babiesItem?.id && <Mask />
        }
    </>
}

const BabiesElementItem = withFirst(props =>{
    const { innerRef } = props;
    
    return <img ref={innerRef} className={classes.ProductBabiesPlay} src={`${IMAGE_GEEKO_LTD}/chicme/20220627/play.svg`} alt="Play" />
});

const BabiesElement = props =>{
    const { selectedProduct } = props;

    const onLoadEvent = () =>{
        if(window.GeekoSensors){
			window.GeekoSensors.Track("ShowVideoExpose", {
                product_id:selectedProduct?.id
			})
		}
    }

    return <React.Fragment>
        <BabiesElementItem initLoad={onLoadEvent} />
    </React.Fragment>
}

const ProductBabiesLooksItem = withFirst(props =>{
    const { innerRef, babiesLooks, selectedProduct } = props;
    const fetchIds = babiesLooks?.map(item =>item?.productCommentId).join(",");
    const [babiesItem,setBabiesItem] = useState(null);
    const [babiesData,setBabiesData] = useState(null);
    const currentIndex = useRef(0);

    const [aPlay,setAPlay] = useState(false);

    // const babiesArr = useCallback(babiesLooks?.reduce((preValue,currentValue) =>{
    //     let arr = [];
    //     currentValue?.imageURLs.forEach(item => {
    //         let disposeItem = {image:item,id:currentValue.productCommentId};

    //         if(currentValue?.videoIds?.length > 0){
    //             disposeItem['videoId'] = currentValue?.videoIds?.[0];
    //         }

    //         arr.push(disposeItem);
    //     });
    //     return [...preValue,...arr]
    // },[]),[babiesLooks]);

    const findCurrentData = (result,id) =>{
        let item = result.find(item=>item.id == id);
        setBabiesItem(item);
    }

    const getBabiesData = async (id, babies) =>{
        let data = null;
        if(!!!babiesData){
            let response = await fetchCommentIds(fetchIds);
            if(response?.code === 200){
                // let resultData = response?.result.map(item =>({...item,images:[...item.images,...item.images],videoId:"6fN39mnvH9k"}));
                // console.log('resultData', resultData)
                setBabiesData(response?.result);
                findCurrentData(response?.result,id);
                data = response?.result;
            }
        }else{
            findCurrentData(babiesData,id);
            data = babiesData;
        }
        setAPlay(true);
        let index = data?.findIndex(item=>item.id == id);
        currentIndex.current = index;
        
        if(window.GeekoSensors){
			window.GeekoSensors.Track("ProductListClick", {
				column:"Show"
			})

            if(babies?.videoIds?.length > 0){
                window.GeekoSensors.Track("ShowVideoClick", {
                    product_id:selectedProduct?.id
                });
            }
		}
    }

    const onBabiesLook = flag =>{
        let index = currentIndex.current;
        if (flag) {
            ++index;
        } else {
            --index;
        }
        setAPlay(false);
        currentIndex.current = index;
        findCurrentData(babiesData,babiesLooks[index]?.productCommentId)
    }

    return <div className={classes.ProductBabiesLooks} ref={innerRef}>
        <div className={classes.Title}><FormattedMessage id="show" defaultMessage="Show" /></div>

        <div className={classes.Content}>
            <Swiper 
                navigation={{
                    prevEl: '#babies-looks-prev',
                    nextEl: '#babies-looks-next',
                    disabledClass:classes.NavigationDisabled
                }} 
                modules={[Navigation]}
                spaceBetween={16}
                slidesPerView="auto"
            >
                {/* {
                    babiesArr.map((item,index)=>{
                        return <SwiperSlide key={index} className={classes.ImageItem} onClick={()=>getBabiesData(item.id)}>
                            <LazyLoadImage className={classes.NormalImage} src={`${IMAGE_GEEKO_LTD}/comment/medium/${item.image}`} alt="ProductBabies" />
                            
                            <img className={classes.ProductBabiesPlay} src={`${IMAGE_GEEKO_LTD}/chicme/20220627/play.svg`} alt="Play" />
                        </SwiperSlide>
                    })
                } */}

                {
                    babiesLooks?.map((babies,index) =>{
                        return babies?.imageURLs.map((image,index2) =>{
                            return <SwiperSlide key={index2} className={classes.ImageItem} onClick={()=>getBabiesData(babies?.productCommentId, babies)}>
                                <LazyLoadImage className={classes.NormalImage} src={`${IMAGE_GEEKO_LTD}/comment/medium/${image}`} alt="ProductBabies" />
                                
                                {
                                    index2===0 && babies?.videoIds?.length > 0 &&  <BabiesElement selectedProduct={selectedProduct} />
                                }
                            </SwiperSlide>
                        })
                    })
                }

                <span id="babies-looks-prev" className={classes.Prev}>
                    <Iconfont>&#xe693;</Iconfont>
                </span>
                <span id="babies-looks-next" className={classes.Next}>
                    <Iconfont>&#xe694;</Iconfont>
                </span>
            </Swiper>

            <ProductBabiesModal 
                babiesItem={babiesItem} 
                babiesItems={babiesLooks} 
                babiesData={babiesData} 
                onBabiesLook={onBabiesLook}
                aPlay={aPlay}
                onClose={()=>{
                    setBabiesItem(null);
                }}
            />
        </div>
    </div>
})

const ProductBabiesLooks = props =>{
    useStyles(classes);
    const { babiesLooks } = props;

    const initLoad = () =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track("ProductListExposure", {
                column:"Show",
            })
        }
    }    

    return <React.Fragment>
        {
            babiesLooks?.length > 0 && <ProductBabiesLooksItem initLoad={initLoad} {...props} />
        }
    </React.Fragment>
    
}

export default ProductBabiesLooks;